<template>
  <div class="loop-content" v-loading="loading">
    <div class="table-head">
      <div>
        <el-button type="primary" @click="loopContorl('all',1)" round>{{$t('control.all_open')}}</el-button>
        <el-button type="info"  @click="loopContorl('all',0)" round>{{$t('control.all_open')}}</el-button>
      </div>
      <el-button icon="el-icon-refresh-right" type="warning" @click="refreshLoopPower()" size="small" round>{{$t('gateway.refresh_3')}}</el-button>
      
    </div>
    <el-table :data="tableData" style="width: 100%;margin-top:0;">
      <el-table-column prop="loop_id" label="ID" width="60"> </el-table-column>
      <el-table-column prop="loop_name" :label="$t('gateway.name')"> </el-table-column>
      <el-table-column
        :label="$t('device.state')"
        prop="ste"
        width="80"
        align="center"
        sortable
      >
        <template slot-scope="scope">
          <i :class="steColorType[scope.row.ste]"></i>
          <span>{{ steType[scope.row.ste] }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('device.voltage')">
        <el-table-column
          prop="sensor.voltage.a"
          label="A"
          min-width="30">
        </el-table-column>
        <el-table-column
          prop="sensor.voltage.b"
          label="B"
          min-width="30">
        </el-table-column>
        <el-table-column
          prop="sensor.voltage.c"
          label="C"
          min-width="30">
        </el-table-column>
      </el-table-column>
      <el-table-column :label="$t('device.current')">
        <el-table-column
          prop="sensor.current.a"
          label="A"
          min-width="30">
        </el-table-column>
        <el-table-column
          prop="sensor.current.b"
          label="B"
          min-width="30">
        </el-table-column>
        <el-table-column
          prop="sensor.current.c"
          label="C"
          min-width="30">
        </el-table-column>
      </el-table-column>
      <el-table-column :label="$t('device.power')">
        <el-table-column
          prop="sensor.power.a"
          label="A"
          min-width="30">
        </el-table-column>
        <el-table-column
          prop="sensor.power.b"
          label="B"
          min-width="30">
        </el-table-column>
        <el-table-column
          prop="sensor.power.c"
          label="C"
          min-width="30">
        </el-table-column>
      </el-table-column>
      <el-table-column :label="$t('control.operate')" prop="type">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.ste"
            :active-value="1"
            :inactive-value="0"
            active-color="#3ba631"
            inactive-color="#B9B9B9"
            @change="loopContorl(scope.row.loop_id,$event)"
          />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import loopApi from "@/api/concentrator/list";
export default {
  name: "concentratorLoop",
  props: {
    id: {
      type: Number,
    },
  },
  data() {
    return {
      loading: false,
      steType: this.$t('concentrator.steType'),
      steColorType: ["valuered", "valuegreen"],
      tableData: []
    };
  },
  methods: {
    getTableData() {
      this.loading = true;
      loopApi.loopList(this.id).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          this.tableData = res.data.data;
          // console.log('tableData',this.tableData)
        }
      });
    },
    loopContorl(loop_id, value) { //回路控制
      let params = {}
      if(loop_id=='all'){
        params = {
          type: 1,
          on: value,
          loop_id: 'all'
        }
      }else{
        params = {
          type: 2,
          on: value,
          loop_id: loop_id
        }
      }
      loopApi.loopControl(this.id, params).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success(this.$t('control.set_success'));
          this.getTableData();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    refreshLoopPower() { //回路控制
      loopApi.loopPower(this.id).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success(this.$t('control.refresh_success'));
          this.getTableData();
        } else {
          this.$message.error(res.data.message);
        }
      });
    }
  },
  mounted() {
    this.getTableData();
  },
};
</script>
<style lang='less' scoped>
.loop-content {
  width: 100%;
  .table-head{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 10px;
    margin-top:-10px;
  }
}
</style>
